





















































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { DataPoint, HSL, Name, NameData } from "../models";
import { paletteGenerator } from "../utils/paletteGenerator";
import GenderIcon from "../components/GenderIcon.vue";
import NameCard from "../components/NameCard.vue";
import NameDeck from "../components/NameDeck.vue";
import VueSwing from "vue-swing/VueSwing.vue";
import { RouteConfig } from "vue-router";

@Component({
  components: {
    GenderIcon,
    NameCard,
    NameDeck,
    VueSwing,
  },
  mounted() {
    const { id, user } = this.$route.params;

    this.$data.kindlingID = id;
    this.$data.userName = user;
  },
})
export default class Ratings extends Vue {
  @Prop({ default: [] }) accepted: Name[];
  @Prop({ default: [] }) rejected: Name[];

  removeAllAccepted() {
    this.$emit("removeAllAccepted");
  }
  removeAllRejected() {
    this.$emit("removeAllRejected");
  }
  removeFromAccepted(name: Name) {
    this.$emit("removeFromAccepted", name);
  }
  removeFromRejected(name: Name) {
    this.$emit("removeFromRejected", name);
  }
}
